import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-708c4e72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop-links" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Faucet ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" veMSTRL ")

import useWeb3 from '@/services/web3/useWeb3';
import { useRoute } from 'vue-router';
import DesktopLinkItem from './DesktopLinkItem.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isGoerli } = useWeb3();

/**
 * COMPOSABLES
 */
const route = useRoute();

/**
 * METHODS
 */
function isActive(page: string): boolean {
  if (route.name === page) return true;
  return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DesktopLinkItem, {
      to: "/",
      active: isActive('home')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('invest')), 1)
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(DesktopLinkItem, {
      to: "/trade",
      active: isActive('trade')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('trade')), 1)
      ]),
      _: 1
    }, 8, ["active"]),
    (_unref(isGoerli))
      ? (_openBlock(), _createBlock(DesktopLinkItem, {
          key: 0,
          to: "/faucet",
          active: isActive('faucet')
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["active"]))
      : _createCommentVNode("", true),
    _createVNode(DesktopLinkItem, {
      to: "/portfolio",
      active: isActive('portfolio')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('portfolio')), 1)
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(DesktopLinkItem, {
      to: "/vebal",
      active: isActive('vebal')
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(DesktopLinkItem, {
      to: "/claim",
      active: isActive('claim')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('claim')), 1)
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}
}

})